import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { APIUS } from "../../config/apius";
import { useMediaQuery } from "react-responsive";
import { Button } from "reactstrap";
import LogoDesktop from "../../assets/logo-desktop.png";
import "./Login.css";
import ToastError from "../NotificationToast/ToastError";
import ToastSuccess from "../NotificationToast/ToastSuccess";
import { ScaleLoader } from "react-spinners";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';

export default function Login() {
  let navigate = useNavigate();
  document.title = "Login";
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const { email, password } = form;

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = useMutation(async (e) => {
    try {
      e.preventDefault();
      setLoading(true);

      const config = {
        headers: { "Content-type": "application/json" },
      };

      const body = JSON.stringify(form);
      const now = Date.now();
      const expiryTime = now + 86400000;

      const response = await APIUS.post("/api/auth/login", body, config);
      localStorage.setItem("token", response.data.data.token);
      localStorage.setItem("token_expiry", expiryTime);
      localStorage.setItem("name-admin", response.data.data.user.username);
      localStorage.setItem("ysb_branch_id", response.data.data.user.ysb_branch_id);
      localStorage.setItem("ysb_branch_name", response.data.data.user.ysb_branch_name);
      localStorage.setItem("photo-admin", response.data.data.user.photo_profile);
      localStorage.setItem("id_admin", JSON.stringify(response.data.data.user.id));
      localStorage.setItem("email_admin", JSON.stringify(response.data.data.user.email));
      localStorage.setItem("level", response.data.data.user.level);
      localStorage.setItem("ysb_school_id", response.data.data.user.ysb_school_id ?? "");
      localStorage.setItem("id_teacher", response.data.data.user.ysb_teacher_id ?? "");
      localStorage.setItem("teacherID", response.data.data.user.id_teacher);
      localStorage.setItem("id_role", response.data.data.user.id_role ?? "");
      localStorage.setItem("ysb_role_name", response.data.data.user.ysb_role_name ?? "");
      localStorage.setItem(
        "teacher_data",
        response.data.data.user.teacher_data !== null
          ? JSON.stringify(response.data.data.user.teacher_data)
          : ""
      );
      localStorage.setItem(
        "menus",
        JSON.stringify(response.data.data.user.aplikasi)
          ? JSON.stringify(response.data.data.user.aplikasi)
          : ""
      );
      localStorage.setItem(
        "role_permission",
        JSON.stringify(response.data.data.user.role_permission)
          ? JSON.stringify(response.data.data.user.role_permission)
          : ""
      );
      localStorage.setItem(
        "roles",
        JSON.stringify(response.data.data.user.roles).length === 0
          ? ""
          : JSON.stringify(response.data.data.user.roles)
      );

      if (response?.status === 200) {
        setLoading(false);
        ToastSuccess.fire({
          icon: "success",
          title: response.data.message,
          background: "#1d3557",
          color: "#ffffff",
        });
        navigate("/dashboard");
      }
    } catch (error) {
      setLoading(false);
      ToastError.fire({
        icon: "error",
        title: `${error.response.data.message}`,
      });
    }
  });

  return (
    <>
      {isTabletOrMobile ? (
        <>
          <div className="bg-phone"></div>

          <div className="card-login-phone">
            <div className="card">
              <h5 className="mb-3" style={{ fontSize: "19px", color: "#252525ff" }}>
                Login
              </h5>

              <form onSubmit={(e) => handleSubmit.mutate(e)}>
                <div className="form-group mb-3">
                  <label className="custem-label-forgot">Email / NIK YSB</label>
                  <input
                    id="email"
                    type="text"
                    className="form-control"
                    value={email}
                    name="email"
                    onChange={handleChange}
                    required
                  />
                  <div className="invalid-feedback">Email / NIK YSB is invalid</div>
                </div>

                <div className="form-group mb-3">
                  <label className="custem-label-forgot">Password</label>
                  <div style={{ position: "relative" }}>
                    <input
                      id="password"
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      value={password}
                      onChange={handleChange}
                      name="password"
                      required
                      data-eye
                      style={{ paddingRight: "45px" }}
                    />
                    <button
                      type="button"
                      onClick={toggleShowPassword}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "12px",
                        transform: "translateY(-50%)",
                        border: "none",
                        background: "transparent",
                        padding: 0,
                        cursor: "pointer",
                        fontSize: "18px",
                        color: "#666",
                      }}
                    >
                      {showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                    </button>
                  </div>
                  <div className="invalid-feedback">Password is required</div>
                </div>

                <div className="btn-login-phone mb-2 mt-4">
                  {loading ? (
                    <Button
                      className="w-100 button-login-phone"
                      type="submit"
                      color="warning"
                      style={{
                        padding: "0px 0px",
                        fontSize: "15px",
                        borderRadius: "50px",
                        backgroundColor: "",
                        color: "white",
                      }}
                    >
                      <ScaleLoader color={"white"} height={25} width={5} />
                    </Button>
                  ) : (
                    <Button
                      className="w-100 button-login-phone"
                      type="submit"
                      color="primary"
                      style={{
                        padding: "8px 0px",
                        fontSize: "15px",
                        borderRadius: "50px",
                        backgroundColor: "#3f5bea",
                        color: "white",
                      }}
                    >
                      Login
                    </Button>
                  )}
                </div>
              </form>
            </div>
          </div>

          <div className="footer-login-phone">
            <div className="footer-center-phone">
              <p>Copyright 2026. Yayasan Syiar Bangsa. All rights reserved.</p>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="page-login-desktop">
            <div className="logo-desktop">
              <img src={LogoDesktop} alt="image" className="img-fluid" />
            </div>

            <div className="row login card-login justify-content-center">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={(e) => handleSubmit.mutate(e)}>
                    <div className="mb-3 input-box">
                      <label className="form-label">Username</label>
                      <input
                        id="email"
                        type="text"
                        className="form-control"
                        value={email}
                        name="email"
                        onChange={handleChange}
                        required
                        autoFocus
                        style={{ width: "100%" }}
                      />
                    </div>

                    <div className="mb-3 input-box">
                      <label className="form-label">Password</label>
                      <div style={{ position: "relative" }}>
                        <input
                          id="password"
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          value={password}
                          onChange={handleChange}
                          name="password"
                          required
                          data-eye
                          style={{ width: "100%", paddingRight: "45px" }}
                        />
                        
                      </div>
                      <button
                          type="button"
                          onClick={toggleShowPassword}
                          style={{
                            position: "absolute",
                            top: "52%",
                            right: "30px",
                            // transform: "translateY(-50%)",
                            transform: "translateX(0%)",
                            border: "none",
                            background: "transparent",
                            padding: 0,
                            cursor: "pointer",
                            fontSize: "18px",
                            color: "#666",
                            width:"30px"
                            
                          }}
                        >
                          {showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                        </button>
                    </div>

                    <div className="btn-login">
                      {loading ? (
                        <Button
                          className="w-100 button-login"
                          type="submit"
                          color="warning"
                          style={{
                            padding: "0px 0px",
                            fontSize: "15px",
                            borderRadius: "5px",
                            backgroundColor: "",
                            color: "white",
                          }}
                        >
                          <ScaleLoader color={"white"} height={25} width={5} />
                        </Button>
                      ) : (
                        <Button
                          className="w-100 button-login"
                          type="submit"
                          color="primary"
                          style={{
                            padding: "10px 0px",
                            fontSize: "15px",
                            borderRadius: "5px",
                            backgroundColor: "#3f5bea",
                            color: "white",
                          }}
                        >
                          Login
                        </Button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="footer-login justify-content-center">
              <p>Copyright 2026. Yayasan Syiar Bangsa. All rights reserved.</p>
            </div>
          </div>
        </>
      )}
    </>
  );
}